var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHojaVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 260,
    viewBox: "0 0 134 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.782 259.015C74.5544 264.861 21.8152 221.598 15.9692 162.37L0 0.583984C59.2273 -5.26206 111.966 38.0012 117.81 97.2043L133.779 258.991L133.782 259.015Z",
    fill: "#33993F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHojaVerde);
export default __webpack_public_path__ + "static/media/hoja_verde.64b4c3c8447e3e4107081ac1d0182bf4.svg";
export { ForwardRef as ReactComponent };